module.exports = __webpack_public_path__ + "media/images/no-image-available-5116d193d4eeba8c596c6e18e2937aea.jpg";